import { fromJS } from 'immutable';

export default {
    setCraftsmen: (state, craftsmen) => {
        return state.setIn(['list'], fromJS(craftsmen)).set('initialized', true);
    },
    updateCraftsmen: (state, craftsmen) => {
        return state.mergeIn(['list'], fromJS(craftsmen));
    },
    setCraftsman: (state, craftsmanId, craftsman) => {
        return state.setIn(['list', craftsmanId.toString()], fromJS(craftsman));
    },
    updateCraftsman: (state, craftsmanId, craftsman) => {
        return state.mergeIn(['list', craftsmanId.toString()], fromJS(craftsman));
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Craftsman/core.js